import template from './uom-payment-codes.html';

const DIRECTIVE_NAME = UomPaymentCodes.DIRECTIVE_NAME = 'ktUomPaymentCodes';
export default function UomPaymentCodes() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: UomPaymentCodesController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            suggestions: `=${DIRECTIVE_NAME}Suggestions`,
            tripId: `=${DIRECTIVE_NAME}TripId`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function UomPaymentCodesController(
    $scope,
    paymentCodesListService,
    hierarchicalPaymentCodesService
) {
    'ngInject';
    const vm = this;
    const FORM_FIELDS = {
        ORGANISATION: 'organisation',
        PROJECT: 'project',
    };

    Object.assign(vm, {
        $onInit,
        isErrorMessageVisible,
        FORM_FIELDS,
        onTaskCodeSelect,
        onAwardCodeSelect,
        valueOrDefault,
        emptyArray,

        getPaymentCodes: paymentCodesListService.getPaymentCodes,
    });

    function onTaskCodeSelect() {
        vm.model.taskCode.Id = vm.taskCode.Id;
    }

    function onAwardCodeSelect() {
        vm.model.awardCode.Id = vm.awardCode.Id;
    }

    function $onInit() {
        vm.paymentCodeData = {...vm.suggestions};

        $scope.$watch(() => vm.model
            && vm.model.organisation
            && vm.model.organisation.Value, onOrganizationChange, true);
    }

    function onOrganizationChange(newValue) {
        vm.childPaymentCode = {};
        Object.assign(vm.model, {
            project: {},
            taskCode: {},
            awardCode: {},
        });

        const {Value: value, Id: paymentCodeId, CustomerLabel} = vm.model.organisation;
        const {tripId} = vm;

        if (!newValue) {
            vm.model.organisation = {Id: paymentCodeId, CustomerLabel};
            return;
        }

        hierarchicalPaymentCodesService.validatePaymentCode({
            value,
            paymentCodeId,
            tripId,
        })
            .then((response) => {
                Object.assign(vm.model.organisation, response);

                if (response.IsValid) {
                    getChildPaymentCodes({
                        paymentCodeId,
                        parentPaymentCodeId: vm.model.organisation.SelectedValueId,
                    })
                        .then(([task, award]) => {
                            vm.taskCode = task;
                            vm.awardCode = award;
                        });
                }
            });
    }

    function getChildPaymentCodes(paymentCode) {
        return hierarchicalPaymentCodesService.getChildPaymentCodes(paymentCode);
    }

    function valueOrDefault(input) {
        return input || 'n/a';
    }

    function emptyArray(input) {
        if (angular.isArray(input)) {
            return input.length > 0 ? null : 'n/a';
        }
        return 'n/a';
    }

    function isErrorMessageVisible(fieldName) {
        const field = vm.paymentCodesForm[fieldName];
        if (!field) {
            return false;
        }
        const {$touched, $dirty} = field;
        const {$submitted} = vm.paymentCodesForm;
        return $touched || $dirty || $submitted;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/uom-payment-codes/uom-payment-codes-component.js